import React, { Fragment } from "react";
import { CDBBreadcrumb, CDBBadge, CDBLink } from "cdbreact";
import { Layout } from "../Layout";
import { TemplateNav } from "../TemplateNav";
import Sidebar from "../Sidebar";

export const Breadcrumb = () => {
  return (
    <div className="d-flex w-100">
      <div style={{height:"100vh", overflow:"hidden initial"}}>
        <Sidebar/>
      </div>
      <Layout>
        <TemplateNav/>
    <div className="r-w">
      <div
        style={{
          margin: "auto",
          width: "80%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="blockcode">
          <div className="header">Breadcrumb</div>
          <div className="description">Breadcrumb</div>
          <div className="example d-block" style={{width:"500px"}}>
            <CDBBreadcrumb color="none">
              <li className="breadcrumb-item" ><CDBLink className="p-0 d-inline" to="#">Home</CDBLink></li>
              <li className="breadcrumb-item"><CDBLink className="p-0 d-inline" to="#">Library</CDBLink></li>
              <li className="breadcrumb-item active">Data</li>
            </CDBBreadcrumb>
            <CDBBreadcrumb color="none">
              <li className="breadcrumb-item"><CDBLink className="p-0" to="#">Home</CDBLink></li>
              <li className="breadcrumb-item active">Library</li>
            </CDBBreadcrumb>
            <CDBBreadcrumb color="none">
              <li className="breadcrumb-item active">Home</li>
            </CDBBreadcrumb>
          </div>
        </div>
      </div>
    </div>
      </Layout>
    </div>
  );
};